class FuseUtils {
	/**
	 * Check if user has permission
	 */
	static hasPermission(authArr: string | string[] | undefined, userRole: string | string[] | undefined): boolean {
		// If no auth required, return true
		if (!authArr || authArr.length === 0) {
			return true;
		}

		// If no user role, return false
		if (!userRole || userRole.length === 0) {
			return false;
		}

		const authArray = Array.isArray(authArr) ? authArr : [authArr];
		const userRoleArray = Array.isArray(userRole) ? userRole : [userRole];

		// Check if user has any of the required roles
		return authArray.some((role) => userRoleArray.includes(role));
	}

	/**
	 * Find item by ID in navigation
	 */
	static findById(o: any, id: string): any {
		if (o.id === id) {
			return o;
		}

		if (o.children) {
			for (const child of o.children) {
				const found = this.findById(child, id);
				if (found) {
					return found;
				}
			}
		}

		return null;
	}
}

export default FuseUtils;
